import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { Container, Row, Col } from "react-bootstrap";

import "./style.css";

const Suspended = () => {
  useEffect(() => {
    localStorage.setItem("baccess", "yes");
    return () => {
      localStorage.removeItem("baccess");
    };
  }, []);

  return (
    <>
      <div className="suspendedbackgroundscreen">
        {/* <div className="bgcolorLogin container-fluid"> */}
        <div className="backgroundbott">
          <Container>
            <div className="cardMainlogin-suspended">
              <Row>
                <Col xs={12} md={12} sm={12} lg={12}>
                  <Container>
                    <div className="loginheaderfrst">
                      <div className="loginLogo">
                        <div>
                          <img
                            alt="logo1"
                            className="logo1-suspended"
                            src={require("../../assets/img/logo-sh.png")}
                          />
                        </div>
                        <div className="vl"></div>
                        <div>
                          <img
                            alt="logo2"
                            className="wateronlogo"
                            src={require("../../assets/img/waterOn_logo.png")}
                          />
                        </div>
                      </div>
                      <div className="suspend-logo-cont">
                        <div>
                          <img
                            alt="logo2"
                            className="suspeneded-img"
                            src={require("../../assets/img/suspend.svg")}
                          />
                        </div>
                      </div>

                      <div className="suspend-msg-cont">
                        <h2 className="suspended-title">Account Suspended</h2>
                        <p className="suspend-msg1">
                          Please clear any unpaid invoices and contact support
                          to restore your account
                        </p>

                        {/* <div className="sus-payment-cont">
                          <img
                            alt="logo2"
                            className="payment-img"
                            src={require("../../assets/img/payment.svg")}
                          />
                          <p1 className="pay-invo-text">Pay Invoices</p1>
                        </div>
                        <Link to="/login" className="support-btn">
                          Talk to support
                        </Link> */}
                      </div>
                    </div>
                  </Container>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        {/* </div> */}
        <div className="footerclass">
          <div>
            {/* <span className="footerSpan">
              <i className="fa fa-phone"></i> +91-777-780-4646
            </span>
            <span>
              <i className="fa fa-at"></i> info@smarterhomes.com
            </span> */}
          </div>
          <div className="footerDivVersion">
            <span>Version 5.5.6© 2023 SmarterHomes Technologies</span>
          </div>
        </div>
      </div>
    </>
  );
};
export default Suspended;
